<template>
  <Modal
    class="scoped full-width"
    title="Import CSV file"
  >
    <QCard class="full-width">
      <QCardSection class="preview-body scroll">
        <div class="row q-pa-md q-gutter-md">
          <QInput
            accept=".csv"
            class="col-6"
            dense
            filled
            hint="Upload CSV"
            square
            type="file"
            @update:model-value="processCsvFile"
          />
          <VueJsonCsv
            v-if="hasSample"
            class="col-5"
            :data="sample"
            name="sample.csv"
          >
            <QBtn
              color="primary"
              flat
              label="Sample.csv"
              no-caps
            />
          </VueJsonCsv>
        </div>
      </QCardSection>

      <QCardActions>
        <div class="full-width flex justify-between">
          <div>
            <QBtn
              v-close-popup
              color="primary"
              flat
              label="Cancel"
              no-caps
              @click="cancel"
            />
            <QBtn
              v-close-popup
              color="black"
              label="Confirm"
              no-caps
              @click="confirm"
            />
          </div>
        </div>
      </QCardActions>
    </QCard>
  </Modal>
</template>

<script>
import Papa from "papaparse";
import VueJsonCsv from "vue-json-csv";

import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "UploadCsvModal",
  components: {
    Modal,
    VueJsonCsv,
  },
  props: {
    sample: {
      type: Array,
      default: null,
    },
  },
  emits: ["cancel", "confirm"],
  data() {
    return {
      items: [],
    };
  },
  computed: {
    hasSample() {
      return Boolean(this.sample);
    },
  },
  methods: {
    processCsvFile([file]) {
      const reader = new FileReader();

      reader.onload = (event) => {
        const csvFile = event.target.result.trim();
        const parsed = Papa.parse(csvFile).data;
        const columns = parsed.shift();

        this.items = parsed.map((values) => {
          // set columns uploaded
          const item = values.reduce((acc, value, index) => {
            if (value) acc[columns[index]] = value;

            return acc;
          }, {});

          return item;
        });
      };

      reader.readAsText(file);
    },
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm", this.items);
      this.$emit("cancel");
    },
  },
};
</script>
